<script>
import Carregando from '~componentes/Carregando.vue';
import pessoaFisicaServico from '../servico';

export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      idAssinatura: 0,
      detalhesAssinatura: {},
      modalVisualizacaoAberto: false,
      carregandoVisualizacao: false,
      visualizacaoArquivoUrl: '',
      tipoVisualizacaoArquivo: '',
      evidenciasAbertas: {},
      quantidadeExibidaLogs: 10
    }
  },
  mounted() {
    this.$root.tituloDaPagina = 'Assinatura Eletrônica - Detalhes do Documento';
    this.$root.botaoAcaoMostrar = false;

    this.idAssinatura = this.$route.params.id;
    this.carregar();
  },
  beforeDestroy() {
    this.revogarVisualizacaoDocumento();
  },
  methods: {
    carregar() {
      return this.buscarDetalhesAssinatura();
    },
    buscarDetalhesAssinatura() {
      this.carregando = true;

      return pessoaFisicaServico
        .buscarDetalhesAssinatura(this.idAssinatura)
        .then(dados => {
          this.detalhesAssinatura = dados || {};
          this.carregando = false;
        })
        .catch(erro => {
          this.carregando = false;
          this.$mensagemErro(erro, 'Ocorreu um erro ao buscar os detalhes do documento.');
        });
    },
    visualizarDocumento() {
      if (!this.possuiDetalhes) {
        return;
      }

      this.modalVisualizacaoAberto = true;
      $('#ModalVisualizarDocumentoAssinatura').modal('show');

      if (!this.visualizacaoArquivoUrl) {
        this.carregarVisualizacaoDocumento();
      }
    },
    fecharModalVisualizacao() {
      this.modalVisualizacaoAberto = false;
      $('#ModalVisualizarDocumentoAssinatura').modal('hide');
      this.revogarVisualizacaoDocumento();
    },
    carregarVisualizacaoDocumento() {
      if (!this.dadosDocumento.caminhoArquivoOriginal) {
        return Promise.resolve();
      }

      this.carregandoVisualizacao = true;
      this.revogarVisualizacaoDocumento();

      return pessoaFisicaServico
        .visualizarArquivoAssinatura(this.idAssinatura)
        .then(blob => {
          const urlFactory = window.URL || window.webkitURL;

          this.tipoVisualizacaoArquivo = blob.type || '';

          const urlBlob = urlFactory.createObjectURL(blob);
          this.visualizacaoArquivoUrl = urlBlob + '#toolbar=0&view=FitH';
        })
        .catch(() => { })
        .then(() => {
          this.carregandoVisualizacao = false;
        });
    },
    revogarVisualizacaoDocumento() {
      if (!this.visualizacaoArquivoUrl) {
        return;
      }

      const urlFactory = window.URL || window.webkitURL;
      urlFactory.revokeObjectURL(this.visualizacaoArquivoUrl);
      this.visualizacaoArquivoUrl = '';
    },
    downloadArquivoAssinatura() {
      return pessoaFisicaServico
        .downloadArquivoAssinatura(this.idAssinatura, this.nomeArquivoDownload)
        .then(arquivo => {
          arquivo.download();
        })
        .catch(erro => {
          this.$mensagemErro(erro, 'Ocorreu um erro ao baixar o documento.');
        });
    },
    voltar() {
      this.$router.push({
        name: this.prefixoRota,
        query: this.$route.query,
      });
    },
    assinarDocumento() {
      const assinante = this.assinaturaPendenteUsuario;

      if (!assinante) {
        return;
      }

      this.$router.push({
        name: `${this.prefixoRota}.assinar`,
        params: { id: assinante.idDocumentoAssinaturaAssinante },
        query: { ...this.$route.query, origem: 'detalhes' },
      });
    },
    classeStatus(status) {
      if (status === 'AGUARDANDO') return 'label-primary';
      if (status === 'ASSINADO') return 'label-success';
      if (status === 'CONCLUIDO') return 'label-success';
      if (status === 'PARCIAL') return 'label-warning';
      if (status === 'CANCELADO') return 'label-danger';

      return 'label-default';
    },
    formatarDataHora(data) {
      if (!data) {
        return '---';
      }

      const dataConvertida = new Date(data);

      if (Number.isNaN(dataConvertida.getTime())) {
        return '---';
      }

      const dataFormatada = dataConvertida.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const horaFormatada = dataConvertida.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      return `${dataFormatada} ${horaFormatada}`;
    },
    extrairExtensaoArquivo(caminhoArquivo) {
      if (!caminhoArquivo) {
        return '';
      }

      const indiceUltimoPonto = caminhoArquivo.lastIndexOf('.');

      if (indiceUltimoPonto === -1) {
        return '';
      }

      return caminhoArquivo.slice(indiceUltimoPonto);
    },
    formatarValorEvidencia(valor, fallback = 'Não coletado') {
      if (valor === null || valor === undefined) {
        return fallback;
      }

      if (typeof valor === 'string' && valor.trim() === '') {
        return fallback;
      }

      return valor;
    },
    alternarEvidencias(idDocumentoAssinaturaAssinante) {
      const atual = !!this.evidenciasAbertas[idDocumentoAssinaturaAssinante];
      this.$set(this.evidenciasAbertas, idDocumentoAssinaturaAssinante, !atual);
    },
    downloadArquivoAssinaturaManifesto() {
      return pessoaFisicaServico
        .downloadArquivoAssinaturaManifesto(this.idAssinatura)
        .then(arquivo => {
          arquivo.download();
        })
        .catch(erro => {
          this.$mensagemErro(erro, 'Ocorreu um erro ao baixar o documento.');
        });
    },
    carregarMaisLogs() {
      this.quantidadeExibidaLogs += 10;
    }
  },
  computed: {
    prefixoRota() {
      return (this.$route.meta && this.$route.meta.prefixoRotaAssinatura) || 'pessoa-fisica.assinatura';
    },
    dadosDocumento() {
      return this.detalhesAssinatura || {};
    },
    assinaturas() {
      return this.detalhesAssinatura.documentosAssinaturaAssinante || [];
    },
    assinaturasConcluidas() {
      return this.assinaturas.filter(item => {
        const status = item.statusAssinatura;
        return status === 'CONCLUIDO' || status === 'ASSINADO';
      });
    },
    assinaturasPendentes() {
      return this.assinaturas.filter(item => {
        const status = item.statusAssinatura;
        return status !== 'CONCLUIDO' && status !== 'ASSINADO';
      });
    },
    assinaturaPendenteUsuario() {
      return this.assinaturas.find(item => item.podeAssinar === true);
    },
    podeAssinarDocumento() {
      return !!this.assinaturaPendenteUsuario;
    },
    possuiDetalhes() {
      return !!this.dadosDocumento.idDocumentoAssinatura;
    },
    documentoEhPdf() {
      return this.tipoVisualizacaoArquivo.indexOf('pdf') !== -1 ||
        (this.dadosDocumento.caminhoArquivoOriginal || '').toLowerCase().slice(-4) === '.pdf';
    },
    nomeArquivoExibicao() {
      if (this.dadosDocumento.nomeArquivo) {
        return this.dadosDocumento.nomeArquivo;
      }

      const caminhoArquivo = this.dadosDocumento.caminhoArquivoOriginal || '';
      const partes = caminhoArquivo.split('\\');

      return partes[partes.length - 1] || 'Documento';
    },
    nomeArquivoDownload() {
      const nomeArquivo = this.nomeArquivoExibicao;

      if (nomeArquivo.indexOf('.') !== -1) {
        return nomeArquivo;
      }

      return `${nomeArquivo}${this.extrairExtensaoArquivo(this.dadosDocumento.caminhoArquivoOriginal)}`;
    },
    quantidadeAssinaturasConcluidas() {
      return this.assinaturasConcluidas.length;
    },
    logsDocumento() {
      const logs = this.detalhesAssinatura.documentosAssinaturaLog || [];
      return [...logs].sort((a, b) => b.idDocumentoAssinaturaLog - a.idDocumentoAssinaturaLog);
    },
    logsExibidos() {
      return this.logsDocumento.slice(0, this.quantidadeExibidaLogs);
    },
    temMaisLogs() {
      return this.quantidadeExibidaLogs < this.logsDocumento.length;
    },
  }
}
</script>

<template>
  <div>
    <div class="modal fade" id="ModalVisualizarDocumentoAssinatura" tabindex="-1" role="dialog" aria-hidden="true"
      data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" aria-label="Close" @click="fecharModalVisualizacao">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title"><b>Visualização do documento</b></h4>
          </div>
          <div class="modal-body detalhes-documento-modal-corpo">
            <div v-if="carregandoVisualizacao" class="detalhes-documento-modal-placeholder">
              <i class="fa fa-spinner fa-pulse fa-2x"></i>
              <p class="margin-top-10 no-margin-bottom">Carregando documento para visualização...</p>
            </div>

            <iframe v-else-if="visualizacaoArquivoUrl && documentoEhPdf" :src="visualizacaoArquivoUrl"
              class="detalhes-documento-modal-preview" title="Visualizacao do documento">
            </iframe>

            <div v-else class="detalhes-documento-modal-placeholder">
              <i class="fa fa-file-pdf-o fa-3x"></i>
              <p class="margin-top-10 margin-bottom-5">
                Não foi possível exibir o documento nesta tela.
              </p>
              <p class="text-muted margin-bottom-10">
                Baixe o arquivo para consultar o conteúdo completo.
              </p>
              <button type="button" class="btn btn-white" @click="downloadArquivoAssinatura">
                <i class="fa fa-download"></i>
                Baixar documento
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" @click="downloadArquivoAssinatura">
              <i class="fa fa-download"></i>
              Baixar
            </button>
            <button type="button" class="btn btn-primary" @click="fecharModalVisualizacao">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <carregando v-if="carregando"></carregando>

    <div class="ibox float-e-margins" v-if="!carregando">
      <div class="ibox-content">
        <div class="row margin-bottom-10">
          <div class="col-sm-8">
            <h2><b>Assinatura eletrônica</b></h2>
            <p class="text-muted no-margin-bottom">
              Consulte os detalhes do documento, assinaturas vinculadas e evidências registradas.
            </p>
          </div>
          <div class="col-sm-4 text-right detalhes-documento-topo-acoes">
            <button type="button" class="btn btn-white margin-right-10" :disabled="!possuiDetalhes"
              @click="visualizarDocumento">
              <i class="fa fa-eye"></i>
              Visualizar
            </button>
            <button type="button" class="btn btn-white margin-right-10" @click="downloadArquivoAssinatura"
              :disabled="!possuiDetalhes">
              <i class="fa fa-download"></i>
              Baixar
            </button>
            <button type="button" class="btn btn-white margin-right-10" @click="downloadArquivoAssinaturaManifesto"
              :disabled="this.dadosDocumento.statusDocumento !== 'CONCLUIDO'">
              <i class="fa fa-download"></i>
              Baixar Manifesto
            </button>
            <button v-if="podeAssinarDocumento" type="button" class="btn btn-primary margin-right-10"
              @click="assinarDocumento">
              <i class="fa fa-pencil"></i>
              Assinar
            </button>
            <button type="button" class="btn btn-secundary" @click="voltar">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </button>
          </div>
        </div>

        <div v-if="possuiDetalhes">
          <div class="row">
            <div class="col-lg-12">
              <h3><b>Informações do documento</b></h3>
            </div>
          </div>

          <div class="row no-margin-top" style="display: flex; flex-wrap: wrap;">
            <div class="col-md-6">
              <div class="bs-callout bs-callout-default detalhes-documento-secao">
                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Nome do arquivo</dt>
                    <dd>
                      <span>
                        {{ nomeArquivoExibicao }}
                      </span>
                    </dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Status</dt>
                    <dd>
                      <span class="label" :class="classeStatus(dadosDocumento.statusDocumento)">
                        {{ dadosDocumento.statusDocumento || '---' }}
                      </span>
                    </dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Tipo</dt>
                    <dd>{{ dadosDocumento.tipoDocumento || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Arquivo de origem</dt>
                    <dd class="detalhes-documento-quebra no-margin-bottom">
                      {{ dadosDocumento.caminhoArquivoOriginal || '---' }}
                    </dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Criado em</dt>
                    <dd>{{ formatarDataHora(dadosDocumento.dataHoraCriacao) }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Alterado em</dt>
                    <dd>{{ formatarDataHora(dadosDocumento.dataHoraAlteracao) }}</dd>
                  </dl>
                </div>

                <div v-if="dadosDocumento.motivoCancelamento" class="alert alert-warning no-margin-bottom">
                  <b>Motivo do cancelamento:</b>
                  {{ dadosDocumento.motivoCancelamento }}
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="bs-callout bs-callout-info detalhes-documento-secao">
                <h4>Integridade e rastreabilidade</h4>
                <p class="margin-bottom-5"><b>Assinaturas concluídas:</b> {{ quantidadeAssinaturasConcluidas }} de {{
                  assinaturas.length }}</p>
                <p class="margin-bottom-5"><b>Hash SHA-256:</b></p>
                <p class="detalhes-documento-quebra no-margin-bottom">
                  {{ dadosDocumento.hashSHA256 || '---' }}
                </p>
                <p class="margin-top-10 margin-bottom-5"><b>Hash SHA-512:</b></p>
                <p class="detalhes-documento-quebra no-margin-bottom">
                  {{ dadosDocumento.hashSHA512 || '---' }}
                </p>
              </div>
            </div>
          </div>

          <div class="hr-line-dashed no-margin-top"></div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="no-margin-top"><b>Assinaturas ({{ assinaturas.length }})</b></h3>
              <div class="table-responsive">
                <table class="table relatorio table-bordered">
                  <thead>
                    <tr>
                      <th>Assinante</th>
                      <th>Papel</th>
                      <th>Status</th>
                      <th class="text-center">Evidências</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="item in assinaturas">
                      <tr>
                        <td>
                          <b>{{ item.nomeAssinante || '---' }}</b><br>
                          <small class="text-muted">{{ item.cpfAssinante || '---' }}</small><br>
                          <small><b>{{ item.statusAssinatura === 'CONCLUIDO' || item.statusAssinatura === 'ASSINADO' ?
                              'Assinado em:' : 'Enviado em:' }}</b> {{ formatarDataHora(item.statusAssinatura ===
                                'CONCLUIDO' || item.statusAssinatura === 'ASSINADO' ? item.dataHoraAssinatura :
                            item.dataHoraCriacao) }}</small>
                        </td>
                        <td>{{ item.papelAssinatura || '---' }}</td>
                        <td>
                          <span class="label" :class="classeStatus(item.statusAssinatura)">
                            {{ item.statusAssinatura || '---' }}
                          </span>
                        </td>
                        <td class="text-center">
                          <button type="button" class="btn btn-white btn-xs"
                            @click="alternarEvidencias(item.idDocumentoAssinaturaAssinante)">
                            <i class="fa"
                              :class="evidenciasAbertas[item.idDocumentoAssinaturaAssinante] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="evidenciasAbertas[item.idDocumentoAssinaturaAssinante]"
                        :key="`${item.idDocumentoAssinaturaAssinante}-evidencias`">
                        <td colspan="4">
                          <div v-if="item.documentoAssinaturaEvidencias"
                            class="bs-callout bs-callout-info no-margin-bottom">
                            <p class="margin-bottom-5"><b>Data da evidência:</b> {{
                              formatarDataHora(item.documentoAssinaturaEvidencias.dataHoraCriacao) }}</p>
                            <p class="margin-bottom-5"><b>IP de origem:</b> {{
                              formatarValorEvidencia(item.documentoAssinaturaEvidencias.ipOrigem) }}</p>
                            <p class="margin-bottom-5"><b>Navegador:</b> {{
                              formatarValorEvidencia(item.documentoAssinaturaEvidencias.navegador) }}</p>
                            <p class="margin-bottom-5"><b>Sistema operacional:</b> {{
                              formatarValorEvidencia(item.documentoAssinaturaEvidencias.sistemaOperacional) }}</p>
                            <p class="margin-bottom-5"><b>Latitude:</b> {{
                              formatarValorEvidencia(item.documentoAssinaturaEvidencias.geolocatizacaoLatitude) }}</p>
                            <p class="margin-bottom-5"><b>Longitude:</b> {{
                              formatarValorEvidencia(item.documentoAssinaturaEvidencias.geolocatizacaoLongitude) }}</p>
                            <p class="margin-bottom-5"><b>User Agent:</b></p>
                            <p class="detalhes-documento-quebra margin-bottom-10">
                              {{ formatarValorEvidencia(item.documentoAssinaturaEvidencias.userAgent) }}
                            </p>
                            <p class="margin-bottom-5"><b>Hash SHA-256:</b></p>
                            <p class="detalhes-documento-quebra margin-bottom-10">
                              {{ formatarValorEvidencia(item.documentoAssinaturaEvidencias.hashSHA256) }}
                            </p>
                            <p class="margin-bottom-5"><b>Hash SHA-512:</b></p>
                            <p class="detalhes-documento-quebra no-margin-bottom">
                              {{ formatarValorEvidencia(item.documentoAssinaturaEvidencias.hashSHA512) }}
                            </p>
                          </div>
                          <div v-else class="bs-callout bs-callout-warning no-margin-bottom">
                            As evidências ainda não estão disponíveis para esta assinatura.
                          </div>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="assinaturas.length === 0">
                      <td colspan="4" class="text-center">Nenhuma assinatura.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="hr-line-dashed"></div>

          <div class="row">
            <div class="col-md-12">
              <h3 class="no-margin-top"><b>Histórico de Ações ({{ logsDocumento.length }})</b></h3>
              <div v-if="logsDocumento.length > 0">
                <ul style="padding-left: 20px;">
                  <li v-for="log in logsExibidos" :key="log.idDocumentoAssinaturaLog" style="margin-bottom: 8px;">
                    <strong>{{ formatarDataHora(log.dataHoraCriacao) }}:</strong> {{ log.descricao }}
                  </li>
                </ul>

                <div v-if="temMaisLogs" class="margin-top-10">
                  <button type="button" class="btn btn-white btn-sm" @click="carregarMaisLogs">
                    <i class="fa-chevron-down"></i>
                    Ver mais
                  </button>
                </div>

              </div>
              <div v-else class="alert alert-info no-margin-bottom">
                Nenhum histórico de ações registrado para este documento.
              </div>
            </div>
          </div>
        </div>

        <div v-else class="alert alert-warning no-margin-bottom">
          Nenhum documento foi encontrado para o identificador informado.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.detalhes-documento-quebra {
  word-break: break-all;
}

.detalhes-documento-secao {
  height: 80%;
}

.detalhes-documento-modal-corpo {
  background: #f3f3f4;
  padding: 0;
}

.detalhes-documento-modal-preview {
  width: 100%;
  height: 80vh;
  min-height: 520px;
  border: none;
  background: #f3f3f4;
}

.detalhes-documento-modal-placeholder {
  height: 80vh;
  min-height: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  color: #676a6c;
  background: #f3f3f4;
}

@media (max-width: 767px) {
  .detalhes-documento-topo-acoes {
    margin-top: 15px;
    text-align: left;
  }

  .detalhes-documento-topo-acoes .btn {
    display: block;
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/DetalhesDocumentoAssinatura.vue